const BASE_URL = "/payable";


export default [
  {
    path: `${BASE_URL}`,
    name: "Payable",
    component: () => import("@/pages/payable/Index.vue"),
  },
  {
    path: `${BASE_URL}/setup`,
    name: "Payable Setup",
    component: () => import("@/pages/payable/purchasePayableSetup/Index.vue"),
  },
  {
    path: `${BASE_URL}/vendor`,
    name: "Vendor",
    component: () => import("@/pages/payable/vendor/Index.vue"),
  },

  {
    path: `${BASE_URL}/purchase-receiving`,
    name: "Purchase Receiving",
    component: () => import("@/pages/payable/purchaseReceiving/Index.vue"),
  },
  {
    path: `${BASE_URL}/payment-journal`,
    name: "Payment Journal",
    component: () => import("@/pages/payable/paymentJournal/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-request`,
    name: "Purchase Request",
    component: () => import("@/pages/payable/purchaseRequest/Index.vue"),
  },
  {
    path: `${BASE_URL}/outstanding-purchase-request`,
    name: "Outstanding Purchase Request",
    component: () => import("@/pages/payable/outstandingPurchaseRequest/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-order`,
    name: "Purchase Order",
    component: () => import("@/pages/payable/purchaseOrder/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-invoicing`,
    name: "Purchase Invoice",
    component: () => import("@/pages/payable/purchaseInvoice/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-credit-memo/:id?`,
    name: "Purchase Credit Memo",
    component: () => import("@/pages/payable/purchaseCreditMemo/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-receipt-detail`,
    name: "Purchase Receipt Line detail",
    component: () => import("@/pages/payable/purchaseReceiptDetail/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-request-detail`,
    name: "Purchase Request Line detail",
    component: () => import("@/pages/payable/purchaseRequestDetail/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-invoice-detail`,
    name: "Purchase Invoice Line detail",
    component: () => import("@/pages/payable/purchaseInvoice/Detail.vue"),
  },
  {
    path: `${BASE_URL}/purchase-order-detail`,
    name: "Purchase Order Line detail",
    component: () => import("@/pages/payable/purchaseOrderDetail/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-requisition-template`,
    name: "Purchase Requisition Template",
    component: () => import("@/pages/payable/purchaseRequisitionTemplate/Index.vue"),
  },
];
